import { render } from "./BaseStationsPage.vue?vue&type=template&id=df865410&scoped=true"
import script from "./BaseStationsPage.vue?vue&type=script&lang=js"
export * from "./BaseStationsPage.vue?vue&type=script&lang=js"

import "./BaseStationsPage.vue?vue&type=style&index=0&id=df865410&lang=css"
import "./BaseStationsPage.vue?vue&type=style&index=1&id=df865410&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df865410"]])

export default __exports__